import { AfriexErrorCode } from '../enums/index.js';
export class AfriexError extends Error {
    constructor(code, meta) {
        super(code);
        this._version = 2;
        this._code = code ?? AfriexErrorCode?.UnknownError;
        this._meta = meta ?? {};
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
    get code() {
        return this._code;
    }
    get meta() {
        return this._meta;
    }
    get version() {
        return this._version;
    }
}
//# sourceMappingURL=AfriexError.js.map